// import React, {useState, useEffect} from 'react';
// import {toast} from "react-toastify";
//
// const DisplayFormError = ({error, setError, getValues}) => {
//     const [nonFieldError, setNonFieldError] = useState("")
//     useEffect(() => {
//         if (error && error?.response?.data) {
//             const errorObject = error.response.data
//             const errorObjectKeys = Object.keys(errorObject)
//             const errorObjectFirstKey = errorObjectKeys.slice(0.1).shift()
//             const formFields = Object.keys(getValues());
//
//             if (errorObjectFirstKey === "non_field_errors" || errorObjectFirstKey === "detail") { // non field errors
//                 // eslint-disable-next-line @typescript-eslint/no-unused-expressions
//                 typeof errorObject[errorObjectFirstKey] === "string"
//                     ? setNonFieldError(errorObject[errorObjectFirstKey])
//                     : setNonFieldError(errorObject[errorObjectFirstKey][0])
//             } else if (Object.keys(errorObject[errorObjectFirstKey])?.slice(0.1).shift() === "non_field_errors") { // @TODO should change to field error
//                 // eslint-disable-next-line @typescript-eslint/no-unused-expressions
//                 typeof errorObject[errorObjectFirstKey][Object.keys(errorObject[errorObjectFirstKey])?.slice(0.1).shift()] === "string"
//                     ? setNonFieldError(errorObject[errorObjectFirstKey][Object.keys(errorObject[errorObjectFirstKey])?.slice(0.1).shift()])
//                     : setNonFieldError(errorObject[errorObjectFirstKey][Object.keys(errorObject[errorObjectFirstKey])?.slice(0.1).shift()][0])
//             } else { // field errors
//                 errorObjectKeys.forEach(fieldName => {
//                     if (formFields.includes(fieldName)) {
//                         setError(fieldName, {
//                             type: 'error',
//                             message:
//                                 typeof errorObject[fieldName] === 'string'
//                                     ? errorObject[fieldName]
//                                     : errorObject[fieldName][0],
//                         });
//                     }
//                 })
//             }
//         }
//     }, [error])
//     return (
//         <>
//             {nonFieldError &&
//                 toast.error(nonFieldError)
//             }
//         </>
//     )
// }
//
// export default DisplayFormError;


import React, { useState, useEffect } from 'react';
import { toast } from "react-toastify";

const DisplayFormError = ({ error, setError, getValues }) => {
    const [nonFieldError, setNonFieldError] = useState("");

    useEffect(() => {
        if (error && error?.response?.data) {
            const errorObject = error.response.data;
            const errorObjectKeys = Object.keys(errorObject);
            const errorObjectFirstKey = errorObjectKeys[0];
            const formFields = Object.keys(getValues());

            if (errorObjectFirstKey === "non_field_errors" || errorObjectFirstKey === "detail") {
                const message = errorObject[errorObjectFirstKey];
                setNonFieldError(typeof message === "string" ? message : message[0]);
            } else if (
                typeof errorObject[errorObjectFirstKey] === "object" &&
                Object.keys(errorObject[errorObjectFirstKey])[0] === "non_field_errors"
            ) {
                const nested = errorObject[errorObjectFirstKey]["non_field_errors"];
                setNonFieldError(typeof nested === "string" ? nested : nested[0]);
            } else {
                errorObjectKeys.forEach(fieldName => {
                    if (formFields.includes(fieldName)) {
                        setError(fieldName, {
                            type: 'error',
                            message:
                                typeof errorObject[fieldName] === 'string'
                                    ? errorObject[fieldName]
                                    : errorObject[fieldName][0],
                        });
                    }
                });
            }
        }
    }, [error]);

    // ✅ فقط وقتی مقدار nonFieldError تغییر کنه toast نمایش داده میشه
    useEffect(() => {
        if (nonFieldError) {
            toast.error(nonFieldError);
        }
    }, [nonFieldError]);

    return null;
};

export default DisplayFormError;
